import React from 'react'

import { ReactComponent as DefaultCatalog } from '../../../assets/catalog/catalog_default.svg'
import { CatalogView } from '../../../containers/resourceCatalog/catalogItem/CatalogContainer.models'
import './CatalogItem.css'

const CatalogItem = (view: CatalogView) => {
  const resource = view.resource

  const isValidUrl = (url: string) => {
    try {
      new URL(url)
      return true
    } catch (_) {
      return false
    }
  }

  function trimText(text: string, maxCharacterNumber: number) {
    return text.length > maxCharacterNumber
      ? text.trim().substring(0, maxCharacterNumber) + '…'
      : text
  }

  return (
    <div className="catalog-box" onClick={() => view.handleClick(resource)}>
      {resource.iconPath !== '' && isValidUrl(resource.iconPath) ? (
        <img
          src={resource.iconPath}
          className="catalog-item-image"
          alt={resource.name}
          title={resource.name}
        />
      ) : (
        <DefaultCatalog className="catalog-item-image" />
      )}
      <div className="catalog-item-content">
        <h3 className="catalog-item-title">{trimText(resource.name, 45)}</h3>
        <p className="catalog-item-description">
          {trimText(resource.description, 130)}
        </p>
      </div>
    </div>
  )
}

export default CatalogItem
